import {
  ChatsByCountriesDataEntry,
  CountriesTable,
  useChatsByCountriesMap,
} from "@jugl-web/domain-resources/analytics/components/ChatsByCountriesWidget";
import { WidgetEmptyStateLabel } from "@jugl-web/domain-resources/analytics/components/WidgetEmptyStateLabel";
import { useTranslations } from "@jugl-web/utils";
import Highcharts from "highcharts";
import "highcharts/modules/map";
import HighchartsReact from "highcharts-react-official";
import { FC } from "react";
import { ReactComponent as GlobeIcon } from "./assets/globe.svg";
import { WidgetContainer } from "../WidgetContainer";
import { WidgetContainerTitle } from "../WidgetContainerTitle";

export const ChatsByCountriesWidget: FC<{
  data: ChatsByCountriesDataEntry[];
}> = ({ data }) => {
  const { t } = useTranslations();
  const {
    chartRef,
    chartCallback,
    options,
    tableRows,
    activeCountryKey,
    setActiveCountryKey,
    isEmpty,
  } = useChatsByCountriesMap(data);

  return (
    <WidgetContainer className="flex h-[550px] items-stretch gap-10 pr-0">
      <div className="flex min-h-0 w-[65%] flex-col gap-8 overflow-hidden">
        <WidgetContainerTitle
          icon={<GlobeIcon className="shrink-0" />}
          title={t({
            id: "cx-page.sessions-by-countries",
            defaultMessage: "Sessions by countries",
          })}
        />
        <div className="min-h-0 w-full max-w-[1020px] flex-1">
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            constructorType="mapChart"
            callback={chartCallback}
            containerProps={{
              className: "h-full w-full",
            }}
            options={options}
          />
        </div>
      </div>
      <div className="flex min-h-0 w-[35%] min-w-0 flex-col justify-center overflow-hidden">
        <div className="flex max-h-full min-h-0 flex-1 flex-col overflow-hidden">
          <div className="jugl__custom-scrollbar min-h-0 flex-1 overflow-y-auto pr-5">
            {!isEmpty ? (
              <CountriesTable
                rows={tableRows}
                activeCountryKey={activeCountryKey}
                onActiveCountryKeyChange={setActiveCountryKey}
              />
            ) : (
              <div className="text-right">
                <WidgetEmptyStateLabel />
              </div>
            )}
          </div>
        </div>
      </div>
    </WidgetContainer>
  );
};
